var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"gjs"}},[_c('h1',[_vm._v("Hello World Component!")])]),_vm._v(" "),_c('div',{attrs:{"id":"blocks"}})])}]

export { render, staticRenderFns }